import { search } from "../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/cnd/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findCNDAgendaCliente(empresa_cnpj, id_cliente = null) {
  return search(
    `${path}/controle${
      id_cliente ? "/" + id_cliente : ""
    }?empresa_cnpj=${empresa_cnpj}`,
    "GET",
    headers
  );
}

export async function refreshCNDAgendaCliente(
  body,
  empresa_cnpj,
  force = false
) {
  return search(
    `${path}/solicitar-atualizacao?empresa_cnpj=${empresa_cnpj}&force=${force}`,
    "POST",
    headers,
    body
  );
}

export async function updateCNDAgendaCliente(id, body, empresa_cnpj) {
  return search(
    `${path}/agendamentoCliente/update/${id}?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );
}

export async function sendEmailCNDAgendaCliente(body) {
  return search(
    `${process.env.REACT_APP_URL_API_ERP}/aws/v1/ses/send`,
    "POST",
    headers,
    body
  );
}
